import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Header from './../../compoments/Header'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import MaterialTable from 'material-table'
import api from './../../services/axios'
import { Redirect } from 'react-router'
import AlertDialog from './../../compoments/AlertDialog'

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Servicos() {

  const role = 'servicos';
  const pageName = 'Serviços';

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [redirect, setRedirect] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [message, setMessage] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const loadData = async () => {
    const data = await api.get('/v1/services')
    setData(data.data.data)
  }

  const deleteService = async (id) => {
    const data = await api.delete('/v1/services/'+id)
    console.log('data', data.data)
    if (!data.data.status) {
      setAlertTitle('Erro')
      setMessage('Não foi possível deletar')
    } else {
      setAlertTitle('')
      setMessage('Deletado com sucesso')
      loadData()
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect}/>}
      <CssBaseline />
      {/* TOPO E MENU DRAWER*/}
      <Header titleHeader={pageName} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Typography color="textPrimary">{pageName}</Typography>
              </Breadcrumbs>
            </Grid>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <MaterialTable
                columns={[
                  { title: 'Nome', field: 'name' },
                  { title: 'Descrição', field: 'description' }
                ]}
                data={data}
                title=""
                actions={[
                  {
                    icon: 'edit',
                    tooltip: 'Editar',
                    onClick: (event, rowData) => {
                      setRedirect(`/${role}/update/${rowData.id}`)
                    }
                  },
                  rowData => ({
                    icon: 'delete',
                    tooltip: 'Deletar',
                    onClick: (event, rowData) => deleteService(rowData.id),
                    disabled: false
                  }),
                  {
                    icon: 'add',
                    tooltip: 'Criar '+pageName,
                    isFreeAction: true,
                    onClick: (event) => setRedirect(`/${role}/create`) 
                  }
                ]}
                options={{
                  actionsColumnIndex: -1
                }}
              />
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}